import { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
import { ElasticSearchService } from '../../../../providers/elastic-search';
import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { RecipeDetailPage } from '../../pages/recipe-detail/recipe-detail';
import { RecipeListCommon } from './recipe-list.common';
import { RecipeData } from '../../providers/recipe-data';

@Component({
  selector: 'recipe-list',
  templateUrl: 'recipe-list.html'
})
export class RecipeListPage extends PageBase {
  public loader: any;
  public pagedFilteredItems: any = [];
  public pageSize: number = 2;
  public pageIndex: number = -1;
  public hasMore = true;
  public isLoading = false;
  public showCategoriesList = false;
  public categoriesList: any;
  public recipeBoxData: any;
  public userId = '';
  public criteria = {
    category: {
      $key: '',
      name: '',
    }
  };
  public categoryUrlSlug = 'all';
  constructor(public nav: NavController,
    public userData: UserData,
    public settings: AppSettings,
    public events: Events,
    public common: RecipeListCommon,
    private navParams: NavParams,
    public recipeData: RecipeData,
    public loadingCtrl: LoadingController,
    public elasticSearchService: ElasticSearchService,
    public recipeBoxGateway: RecipeBoxDataGateway) {
    super(settings, events, nav, userData);
    // this.criteria.category = navParams.get('category');
    this.categoryUrlSlug = navParams.get('categoryUrlSlug');


  }
  ngAfterViewInit() {

  }

  loadPage() {
    return new Promise((resolve, reject) => {
      this.pageIndex += 1;
      this.getRecipesData().subscribe((recipes) => {
        if (recipes.length === 0) {
          this.hasMore = false;
        }
        Array.prototype.push.apply(this.pagedFilteredItems, recipes);
        resolve();
      });
    });
  }
  loadMoreItems(infiniteScroll) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.loadPage().then(() => {
      infiniteScroll.complete();
      this.isLoading = false;
    });

  }

  viewRecipeDetail(recipe) {
    this.nav.push(RecipeDetailPage, { id: recipe.$id ? recipe.$id : recipe.$key });
  }

  loadData() {
    return new Promise((resolve, reject) => {
      this.pagedFilteredItems = [];
      this.hasMore = true;
      this.pageIndex = -1;
      this.loader.present();
      this.getAllCategoriesData().subscribe(categoriesRes => {
        console.log(categoriesRes);
        this.criteria.category = _.find(categoriesRes, (value: any, key) => {
          return value.urlSlug == this.categoryUrlSlug;
        });
        console.log(this.criteria.category);
        if (!this.criteria.category)
          this.criteria.category = { $key: 'All', name: 'All' };
        this.loadPage().then(() => {
          this.loader.dismiss();
        });
        resolve();
      });
      // Observable.from([this.getAllCategoriesData(), this.getRecipesData()]).combineAll().subscribe(() => {
      //   this.loadPage();
      //   this.loader.dismiss();
      //   resolve();
      // });

    });
  }


  addOrRemoveUserRecipe(recipe) {
    if (!recipe.isFavorite) {
      this.recipeBoxData.add(this.userId, recipe).then(result => {
        if (result)
          recipe.isFavorite = true;
      });
    }
    else {
      this.recipeBoxData.remove(this.userId, recipe).then(result => {
        if (result)
          recipe.isFavorite = false;
      });
    }
  }

  public getRecipesData() {
    return this.recipeData.getRecipesFullData(this.criteria.category.$key,'', this.userId, this.pageSize, this.pageIndex).map(recipes => {
      console.log(recipes);
      return recipes.items;
    });
  }
  public getRecipes(category?) {
    this.pagedFilteredItems = [];
    this.hasMore = true;
    this.pageIndex = -1;
    this.loader.present();

    if (category)
      this.criteria.category = category;
    else
      this.criteria.category = { $key: 'All', name: 'All' };
    this.loadPage().then(() => {
      this.loader.dismiss();
      this.showCategoris();

    });
  }
  public getAllCategoriesData() {
    return this.recipeData.getAllCategories().map((categories) => {
      if (categories) {
        this.categoriesList = categories;
        // self.loadPage();
      }
      return categories;
    });
  }
  ionViewDidEnter() {
    //   if (this.criteria.category)
    //     this.categoryName = this.criteria.category.name;
    //   else
    //     this.categoryName = 'ALL';
    this.loader = this.loadingCtrl.create();
    
    this.userId = this.currentUser ? this.currentUser.uid : null;
    this.recipeBoxData = this.recipeBoxGateway.getService(this.userId);
    this.loadData();
  }

  public showCategoris() {
    this.showCategoriesList = !this.showCategoriesList;
  }

}


// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-list/recipe-list.ts